import {
  ISocketNotificationCounter,
  SocketNotificationCounterType,
} from '../../services/websockets/types';
import { ECounters } from '../api/models/counters/counters.types';

export const counterSerializer = (
  rawCounter: ISocketNotificationCounter
): ICounterUpdate => ({
  type: counterTypeMapper[rawCounter.type],
  value: Number(rawCounter.value),
});

const counterTypeMapper = {
  [SocketNotificationCounterType.MESSAGE]: ECounters.MESSAGE,
  [SocketNotificationCounterType.FAVORITE]: ECounters.FAVORITE,
  [SocketNotificationCounterType.VISIT]: ECounters.VISIT,
};

export interface ICounterUpdate {
  type: ECounters;
  value: number;
}
